/* eslint-disable no-nested-ternary */
import { useTranslate } from 'hooks/useTranslate';
import { Tooltip } from 'react-tooltip';
import { formatNumber } from 'utils/formats';

import { hasInternalView } from 'utils/showDetails';

import '../PartnerBook.scss';

function PlanSummaryPeriodsTable({
  view,
  summary,
  plansNames,
  periods,
  values,
  isFormatted = true,
}) {
  const { t } = useTranslate();

  if (hasInternalView()) {
    console.log('cclog > PlanSummaryPeriodsTable'); // eslint-disable-line no-console
  }

  const formatValue = (value) => (isFormatted ? formatNumber(value) : value);

  return (
    summary && (
      <div
        className={
          view === 0 || view === 1 ? 'nk-block w-100 overflow-hidden' : 'd-none'
        }
      >
        <div className="card card-bordered w-100">
          <div className="table-responsive">
            <table
              className="table table-striped text-right cloned pos-abs bg-white border-right partner-book-table"
              id="table-overlap"
            >
              <tr className="text-center table-header">
                <th className="w-200px">&nbsp;</th>
              </tr>
              <tr className="text-center table-subheader">
                <td className="w-200px">{t('Plans')}</td>
              </tr>

              {Object.keys(summary.phantoms)?.map((planId, index) => (
                <>
                  <tr>
                    <td
                      id={planId}
                      className="text-left w-200px d-block text-ellipsis"
                    >
                      {plansNames[planId]}
                      <Tooltip anchorId={planId} place="bottom">
                        {plansNames[planId]}
                      </Tooltip>
                    </td>
                  </tr>
                </>
              ))}

              {Object.keys(summary.stockOptions)?.map((planId, index) => (
                <>
                  <tr>
                    <td
                      id={planId}
                      className="text-left w-200px d-block text-ellipsis"
                    >
                      {plansNames[planId]}
                      <Tooltip anchorId={planId} place="bottom">
                        {plansNames[planId]}
                      </Tooltip>
                    </td>
                  </tr>
                </>
              ))}

              {Object.keys(summary.warrants)?.map((planId, index) => (
                <>
                  <tr>
                    <td
                      id={planId}
                      className="text-left w-200px d-block text-ellipsis"
                    >
                      {plansNames[planId]}
                      <Tooltip anchorId={planId} place="bottom">
                        {plansNames[planId]}
                      </Tooltip>
                    </td>
                  </tr>
                </>
              ))}
            </table>

            <table
              className="table table-striped text-right border-right partner-book-table"
              id="periodsTable"
              style={{
                width: `${periods.length * 400 + 210}px`,
              }}
            >
              <tr className="text-center table-header">
                <th className="w-200px d-block border-right">&nbsp;</th>

                {periods?.map((period) => (
                  <th
                    className="border-right"
                    style={{ height: '50px !important' }}
                    colSpan={5}
                  >
                    {period}
                  </th>
                ))}
              </tr>

              <tr className="text-center">
                <td className="w-200px d-block table-subheader border-right">
                  {t('Plans')}
                </td>
                {periods?.map((period) => (
                  <>
                    <td
                      className="table-subheader border-right"
                      style={{ height: '50px !important' }}
                    >
                      {t('Total')}
                    </td>
                    <td
                      className="no-break table-subheader border-right"
                      style={{ height: '50px !important' }}
                    >
                      {t('AssignedUnits')}
                    </td>
                    <td
                      className="no-break table-subheader border-right"
                      style={{ height: '50px !important' }}
                    >
                      {t('Vested')}
                    </td>
                    <td
                      className="no-break table-subheader border-right"
                      style={{ height: '50px !important' }}
                    >
                      {t('CanceledUnits')}
                    </td>
                    <td
                      className="no-break table-subheader border-right"
                      style={{ height: '50px !important' }}
                    >
                      {t('Acquired')}
                    </td>
                  </>
                ))}
              </tr>

              {Object.keys(summary.phantoms)?.map((planId, index) => (
                <>
                  <tr>
                    <td
                      id={planId}
                      className="text-left w-200px d-block text-ellipsis border-right"
                    >
                      {plansNames[planId]}
                      <Tooltip anchorId={planId} place="bottom">
                        {plansNames[planId]}
                      </Tooltip>
                    </td>
                    {values[planId].map((value) => (
                      <td
                        className={
                          index === 0
                            ? 'text-right text-ellipsis border-right'
                            : 'text-right border-right'
                        }
                        style={{ height: '50px !important' }}
                      >
                        {formatValue(value)}
                      </td>
                    ))}
                  </tr>
                </>
              ))}

              {Object.keys(summary.stockOptions)?.map((planId, index) => (
                <>
                  <tr>
                    <td
                      id={planId}
                      className="text-left w-200px d-block text-ellipsis border-right"
                    >
                      {plansNames[planId]}
                      <Tooltip anchorId={planId} place="bottom">
                        {plansNames[planId]}
                      </Tooltip>
                    </td>
                    {values[planId].map((value) => (
                      <td
                        className={
                          index === 0
                            ? 'text-right text-ellipsis border-right'
                            : 'text-right border-right'
                        }
                        style={{ height: '50px !important' }}
                      >
                        {formatValue(value)}
                      </td>
                    ))}
                  </tr>
                </>
              ))}

              {Object.keys(summary.warrants)?.map((planId, index) => (
                <>
                  <tr>
                    <td
                      id={planId}
                      className="text-left w-200px d-block text-ellipsis border-right"
                    >
                      {plansNames[planId]}
                      <Tooltip anchorId={planId} place="bottom">
                        {plansNames[planId]}
                      </Tooltip>
                    </td>
                    {values[planId].map((value) => (
                      <td
                        className={
                          index === 0
                            ? 'text-right text-ellipsis border-right'
                            : 'text-right border-right'
                        }
                        style={{ height: '50px !important' }}
                      >
                        {formatValue(value)}
                      </td>
                    ))}
                  </tr>
                </>
              ))}
            </table>
          </div>
        </div>
      </div>
    )
  );
}

export default PlanSummaryPeriodsTable;
